"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRepository = void 0;
const react_1 = require("react");
const context_1 = require("../context");
/**
 * Returns a Repository instance from the RepositoryContext
 */
const useRepository = () => react_1.useContext(context_1.RepositoryContext);
exports.useRepository = useRepository;
//# sourceMappingURL=use-repository.js.map